export default 'https://tme.understood.org/assets/pizza.d30c5ae3.lottie'